import { useEffect } from 'react';

export function SignInRedirect() {
  useEffect(() => {
    window.location.assign(`/oauth2/authorization/cognito`);
  }, []);

  return <div>Redirecting...</div>;
}
